import { string, number, object, array } from 'yup';
import { buildConditionalSchema } from '../utils/yup';

const phoneNumberRegex: RegExp = /^\(\d{3}\)\s\d{3}-\d{4}$/;
const dateRegex: RegExp = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
const monthDateRegex: RegExp = /^(0[1-9]|1[0-2])\/\d{4}$/;

const generalInformationSchema = object().shape({
  name: string().label('Name').required().trim(),
  ssn: string().label('SSN').required().trim(),
  birthdate: string().label('Date of Birth').required().trim(),
  phone: string().label('Phone Number').required().matches(phoneNumberRegex, 'Phone Number must be in format (123) 456-7890'),
  email: string().label('E-mail').email().required(),
  currentAddress: string().label('Current Address').required(),
  previousAddress: string().label('Previous Address'),
});

const driverLicensesValidationSchema = object({
  licenses: array(
    object({
      state: string().label('State').required('State is required'),
      license: string().label('License Number').required('License Number is required'),
      type: string().label('Type').required('Type is required'),
      expiration: string().label('Expiration Date').required('Expiration Date is required'),
    })
  ).min(1, 'At least one license is required'),
});

const ticketsAndAccidentsValidationSchema = object({
  incidents: array(
    buildConditionalSchema({
      date: { label: 'Date', message: 'Date is required' },
      description: { label: 'Description', message: 'Description is required' },
      injuries: { label: 'Injuries / Fatalities', message: 'Injuries / Fatalities is required' },
    })
  ),
});

const employmentRecordsValidationSchema = object({
  records: array(
    buildConditionalSchema({
      employer: { label: 'Employer', message: 'Employer is required' },
      from: {
        label: 'Employed From',
        message: 'Start date is required',
        extra: schema => schema.matches(monthDateRegex, 'Date must be in format MM/YYYY'),
      },
      to: {
        label: 'Employed To',
        message: 'End date is required',
        extra: schema => schema.matches(monthDateRegex, 'Date must be in format MM/YYYY'),
      },
      address: { label: 'Address', message: 'Address is required' },
      phone: {
        label: 'Phone Number',
        message: 'Phone Number is required',
        extra: schema => schema.matches(phoneNumberRegex, 'Phone Number must be in format (123) 456-7890'),
      },
      supervisor: { label: 'Supervisor', message: 'Supervisor is required' },
      position: { label: 'Position', message: 'Position is required' },
      leavingReason: { label: 'Reason For Leaving', message: 'Reason is required' },
    })
  ),
});

const emergencyContactValidationSchema = object({
  emergencyContacts: array(
    object({
      name: string().label('Name'),
      phone: string().label('Phone Number'),
      address: string().label('Address'),
      relation: string().label('Relation')
    })
  )
});

const representativeValidationSchema = object({
  representative: object().shape({
    name: string().label('Sierra Representative').required('Representative name is required'),
    title: string().label('Title').required('Title is required'),
  }),
});

export const hiringDriverValidationSchema = object({
  ...generalInformationSchema.fields,
  ...driverLicensesValidationSchema.fields,
  ...ticketsAndAccidentsValidationSchema.fields,
  ...employmentRecordsValidationSchema.fields,
  ...emergencyContactValidationSchema.fields,
  ...representativeValidationSchema.fields,
});

const ticaContractorInformation = object({
  name: string().label("Name of IC's business").required("Name of IC's business is required"),
  type: string().label("Type of business").required("Type of business is required"),
  phone: string().label('Phone Number').required().matches(phoneNumberRegex, 'Phone Number must be in format (123) 456-7890'),
  email: string().label('E-mail').email().required(),
  fax: string().label('Fax').matches(phoneNumberRegex, 'Phone Number must be in format (123) 456-7890'),
  effectiveDate: string().label("Effective Date").required("Effective Date is required"),
})

const ticaOfficesList = object({
  offices: array(
    object({
      address: string().label('Address').required('Address is required'),
    })
  ).min(1, 'At least one address is required'),
});

export const ticaValidationSchema = object({
  ...ticaContractorInformation.fields,
  ...ticaOfficesList.fields,
})
//
// emergency: object().shape({
//   contact: string().label('Emergency Contact').required('Emergency contact name is required'),
//   relation: string().label('Relation').required('Relation is required'),
// }),